import { LanguageSpoken } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<LanguageSpoken>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const languagesSpokenReducer = createReducer<State, Actions>(initialState, {
  [actions.getLanguagesSpoken.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getLanguagesSpoken.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getLanguagesSpoken.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getLanguagesSpoken.reset.type]: actionsHandlers.handleGetManyReset,
});

export default languagesSpokenReducer;
